import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const studyProgramsApi = createApi({
  reducerPath: 'studyProgramsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  tagTypes: ['StudyPrograms'],
  endpoints: (builder) => ({
    getStudyPrograms: builder.query({
      query: () => ({
        url: urls.studyPrograms,
      }),
      providesTags: ['StudyPrograms'],
    }),

    getStudyProgramsAdmin: builder.query({
      query: ({ archived = false }) => ({
        url: `${urls.studyPrograms}?archived=${archived}`,
      }),
      providesTags: ['StudyPrograms'],
    }),

    getStudyProgramsForIngProjects: builder.query({
      query: () => ({
        url: urls.studyProgramsIng,
      }),
      providesTags: ['StudyPrograms'],
    }),

    getStudyProgramsIngState: builder.query({
      query: () => ({
        url: urls.studyProgramsIngState,
      }),
      providesTags: ['StudyPrograms'],
    }),

    getStudyProgramsIngAll: builder.query({
      query: () => ({
        url: urls.studyProgramsIngAll,
      }),
      providesTags: ['StudyPrograms'],
    }),
    getStudyProgramsBcIngAll: builder.query({
      query: () => ({
        url: urls.studyProgramsBcIngAll,
      }),
      providesTags: ['StudyPrograms'],
    }),

    getStudyProgramsPhdAll: builder.query({
      query: () => ({
        url: urls.studyProgramsPhdAll,
      }),
      providesTags: ['StudyPrograms'],
    }),

    getStudyProgram: builder.query({
      query: (id) => ({
        url: `${urls.studyPrograms}/${id}`,
      }),
      providesTags: ['StudyPrograms'],
    }),

    saveStudyProgram: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: `${urls.studyPrograms}/${req.id}`,
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.studyPrograms,
            method: 'POST',
            data: req.body,
          };
        }
      },
      invalidatesTags: ['StudyPrograms'],
    }),

    deleteStudyProgram: builder.mutation({
      query: (id) => ({
        url: `${urls.studyPrograms}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StudyPrograms'],
    }),
  }),
});

export const {
  useGetStudyProgramsQuery,
  useGetStudyProgramsAdminQuery,
  useGetStudyProgramsForIngProjectsQuery,
  useGetStudyProgramsIngStateQuery,
  useGetStudyProgramsIngAllQuery,
  useGetStudyProgramsBcIngAllQuery,
  useGetStudyProgramsPhdAllQuery,
  useGetStudyProgramQuery,
  useSaveStudyProgramMutation,
  useDeleteStudyProgramMutation,
} = studyProgramsApi;
